import React from 'react'
import { Card, CardBody, Col, FormGroup, Input, Label, Table } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import { openInvoicesData } from '../../../Data/Dashboard/Ecommerce'
import { Btn, H6, Image } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { Link } from 'react-router-dom'

export default function OpenInvoices() {
    return (
        <Col xxl={6} xl={7} className="box-col-7">
            <Card>
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Open Invoices "} />
                <CardBody className="pt-0 open-invoice">
                    <div className="table-responsive theme-scrollbar">
                        <div className="dataTables_wrapper no-footer">
                            <div className="dataTables_filter">
                                <label>Search:<input type="search" /></label>
                            </div>
                            <Table className="dataTable no-footer display">
                                <thead>
                                    <tr role="row">
                                        <th className="sorting_asc">
                                            <FormGroup check>
                                                <Input type="checkbox" />
                                                <Label check />
                                            </FormGroup>
                                        </th>
                                        <th className="sorting">Invoice</th>
                                        <th className="sorting">Customer</th>
                                        <th className="sorting">Status</th>
                                        <th className="sorting">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {openInvoicesData.map((item) => (
                                        <tr role="row" className="even" key={item.id}>
                                            <td className="sorting_1">
                                                <FormGroup check>
                                                    <Input type="checkbox" />
                                                    <Label check />
                                                </FormGroup>
                                            </td>
                                            <td>{item.invoice}</td>
                                            <td>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0">
                                                        <Image src={dynamicImage(`dashboard-2/user/${item.image}`)} alt="" />
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product_list`}>
                                                            <H6>{item.name}</H6><span>{item.email}</span>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <Btn color={item.color}>{item.status}</Btn>
                                            </td>
                                            <td>${item.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}